// Implements React's `Profiler` onRender signature. The parameters are kept to
// document that contract even though the body is a no-op; uncomment the log to
// inspect render timings.
export const onRender = (
  _id: string,
  _phase: string,
  _actualDuration: number,
  _baseDuration: number,
  _startTime: number,
  _commitTime: number,
) => {
  // console.log(_id, _phase, _actualDuration, _baseDuration);
};
